module.exports = {
      id: "undo_inside_the_square-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#undo_inside_the_square-usage",
      toString: function () {
        return this.url;
      }
    }